import React from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import { ifProp } from 'styled-tools';


import { Button } from 'components';
import { Icon } from './Icon';

const StyledButton = styled(Button)`
  background-color: #d1e0f0;
  color: #404040;
  font-weight: bold;
  font-size: 18px;
  border-width: 0;
  padding: 10px 35px;
  line-height: 34px;
  height: 50px;
  width: 100%;
  border-top-left-radius: 0px;
  border-top-right-radius: 0px;
  box-shadow: none;
  display: block;
  border: 1px solid #c7d9eb;
  border-bottom: 0;

  &:hover, &:focus{
    color: #404040;
  }

  ${ifProp('selected', css`
    background-color: #fff !important;
    color: #404040;
    box-shadow: 0px 0px 15px 0px rgba(141,191,231,0.3) !important;
    border: 1px solid #dde6f0 !important;
    border-bottom: 0 !important;
  `, css`
    &:hover, &:focus {
      background-color: #c7d9eb;
      color: #404040;
      box-shadow: none;
      border: 1px solid #c7d9eb !important;
      border-bottom: 0 !important;
    }
  `)}

`;
const SelectButton = ({ name, first, last, selected, tabIndex, onClick }) => (
  <StyledButton onClick={onClick} selected={selected} tabIndex={tabIndex}><Icon first={first} last={last} /> {name}</StyledButton>
);
SelectButton.propTypes = {
  id: PropTypes.string.isRequired,
  name: PropTypes.string,
  first: PropTypes.bool,
  last: PropTypes.bool,
  selected: PropTypes.bool,
  tabIndex: PropTypes.number,
  onClick: PropTypes.func,
};

export { SelectButton };



// WEBPACK FOOTER //
// ./src/components/organisms/DepartureSelectorGroup/SelectButton.js